import { PageModuleData, PageModuleStatus } from "entities/pages/types";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";

type Params = {
  moduleId: string;
  status: PageModuleStatus;
  brandId: string;
  settingId: string;
};

export const updateSettingModuleStatus = async ({
  brandId,
  settingId,
  moduleId,
  status,
}: Params) => {
  const collectionRef = collection(
    db,
    `brands/${brandId}/settings/${settingId}/modules`,
  );

  await updateDoc(doc(collectionRef, moduleId), {
    status,
    updatedAt: new Date(),
  });

  const moduleTemplateSnapshot = await getDoc(doc(collectionRef, moduleId));

  const updatedModuleTemplate = moduleTemplateSnapshot.data() as PageModuleData;

  return updatedModuleTemplate;
};
